import React, { useEffect, useRef, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../_store/_reducers/auth";
import { resetEvents } from "../_store/_reducers/eventList";
import { removePrinterData } from "../_store/_reducers/printer";
import { getSelectedEventDetails, removeData } from "../_store/_reducers/user";
import { removeKioskData } from "../_store/_reducers/kiosk";
import * as images from "../Utilities/Images";
import { useNavigate, useLocation } from "react-router-dom";
import { FiCamera } from "react-icons/fi";
import { userService } from "../_services";
import toast from "react-hot-toast";

const DashboardHeader = ({
  handleButtonClick,
  handleCollapse,
  handleKioskModeClick,
  handleGuestClick,
  showBorder,
  handleRefresh,
  handleClick,
  collapseNav,
  handleCameraClick // Added this prop for better navigation
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef(null);
  const eventDetail = useSelector(getSelectedEventDetails);
  let eventId = eventDetail?.eventId;
  const [isLoadingEventData, setisLoadingEventData] = useState(false)

  // Determine if we should show shadow (for cam and kiosk routes)


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        if (collapseNav && typeof handleCollapse === 'function') {
          handleCollapse();
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [collapseNav, handleCollapse]);

  const handleLogout = () => {
    console.log("handleLogout")
    dispatch(logout());
    dispatch(removeData());
    dispatch(removePrinterData());
    dispatch(removeKioskData());
    dispatch(resetEvents());
    localStorage.clear();
    navigate("/");
  };

  const handleRefreshAndFetchOrrders = async () => {
    try {
      setisLoadingEventData(true)
    let data = await userService.getOrders(eventId);
    toast.success("Event orders data fetched successfully")
    } catch (error) {
      toast.error("Unable to load event orders details")
    }
    finally {
      setisLoadingEventData(false)
      // window.location.reload(); // Refresh the page to reset the camera and state
    }
  }

  const navItems = [
    {
      label: "Camera Mode",
      icon: <FiCamera className="qrCodeImg" />,
      onClick: handleCameraClick || (() => navigate("/dashboard/cam")),
      showOnDesktop: true,
      path: "/dashboard/cam"
    },
    {
      label: "Kiosk Mode",
      icon: <img src={images.Maximize2} alt="kioskIcon" className="qrCodeImg" />,
      onClick: handleKioskModeClick,
      showOnDesktop: true,
      path: "/dashboard/kiosk-mode"
    },
    {
      label: "Add Guest Badge",
      icon: <img src={images.questBadge} alt="questBadgeImg" className="qrCodeImg" />,
      onClick: handleGuestClick,
      showOnDesktop: true
    },
    {
      label: "Badge Designer",
      icon: <img src={images.QrCode} alt="qrCodeImg" className="qrCodeImg" />,
      onClick: handleClick,
      showOnDesktop: true
    },
  ];
  console.log(location.pathname.includes('/dashboard/cam'), "location.pathname");

  const renderNavButtons = (isMobile = false) => {
    return (
      <>
        {navItems.map((item, index) => (
          <button
            key={index}
            onClick={item.onClick}
            className={`btn dashbord-btn backBtnTxt ${isMobile ? "w-100 text-start d-flex align-items-center gap-2" : "badgeHeaderBtn"} ${location.pathname.includes(item.path) ? "border border-1" : ""}`}
          >
            {item.icon}
            {item.label}
          </button>
        ))}
        {isMobile && (
          <button
            onClick={handleRefreshAndFetchOrrders}
            className={`btn dashbord-btn backBtnTxt w-100 text-start d-flex align-items-center gap-2 ${showBorder ? "show_border" : ""}`}
          >
            <img src={images.RefreshCw} alt="refreshIcon" className="qrCodeImg" />
            Refresh Data
          </button>
        )}
      </>
    );
  };

  return (
    <div className={`scanningHeader py-3 px-3 px-md-4 `}>
      {isLoadingEventData && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center" 
          style={{ 
            backgroundColor: 'rgba(0,0,0,0.7)', 
            zIndex: 9999,
            backdropFilter: 'blur(4px)'
          }}
        >
          <div className="spinner-border text-light mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <h4 className="text-white fw-medium tracking-wider">{
            "Fetching updated event order details."
          }</h4>
        </div>
      )}
      <div className="d-flex justify-content-between align-items-center w-100 flex-wrap gap-3">
        {/* Left Side: Back and Title */}
        <div className="d-flex align-items-center gap-2 gap-md-3 flex-grow-1 min-w-0">
          <div className="backAnchor mb-0 flex-shrink-0" onClick={handleButtonClick}>
            <img src={images.leftArrow} alt="backArrow" style={{ width: '20px' }} />
            <p className="backBtnTxt mb-0 d-none d-sm-block">Back</p>
          </div>
          <h1 className="badgeTittle mb-0 fs-5 fs-sm-4 fs-md-3 text-truncate">BADGES+</h1>
        </div>

        {/* Right Side: Navigation and Hamburger */}
        <div className="d-flex align-items-center gap-2 gap-md-3">
          {/* Desktop Navigation */}
          <div className="collapsableNavBar d-none d-lg-flex align-items-center gap-2">
            {renderNavButtons()}
            <img
              src={images.RefreshCw}
              alt="refreshIcon"
              title="Fetch updated event order details and refresh the database"
              className={`refreshBtn cursor-pointer ${showBorder ? "show_border" : ""}`}
              onClick={handleRefreshAndFetchOrrders}
            />
            <button className="btn logout-btn d-flex align-items-center gap-2" onClick={handleLogout}>
              <img src={images.logoutIcon} alt="LogoutIcon" className="logoutIcon" />
              Logout
            </button>
          </div>

          {/* Hamburger Icon for Mobile/Tablet */}
          <div className="d-lg-none">
            <i className="fa-solid fa-bars-staggered headerCollapseIcon fs-3 cursor-pointer text-white" onClick={handleCollapse}></i>
          </div>
        </div>
      </div>

      {/* Mobile/Tablet Collapsed Menu */}
      {collapseNav && (
        <div ref={menuRef} className="navbarCollapseData d-lg-none mt-3 p-3 rounded shadow-lg">
          <div className="d-flex flex-column gap-2">
            {renderNavButtons(true)}
            <button className="btn logout-btn w-100 text-start d-flex align-items-center gap-2" onClick={handleLogout}>
              <img src={images.logoutIcon} alt="LogoutIcon" className="logoutIcon" />
              Logout
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DashboardHeader;